import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { getRouterLinkUrlById } from '@lsq-frontend/common-ui';
import { AR_APPLICATION, atlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { RouteQueryParams, UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { combineLatest, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EulaService } from './eula.service';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';

@Injectable({
    providedIn: 'root'
})
export class NoEulaGuard implements CanActivate {
    constructor(
        private _userService: UserService,
        private _eulaService: EulaService,
        private _router: Router
    ) {
        SingletonServiceGuard.register('NoEulaGuard');
    }

    public eulaWhiteListClaims = [DashboardClaim['Application'], DashboardClaim['ProspectApply']];

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const loginUrl = `/${UiRoutes.Login}`;
        const eulaUrl =
            state.url === '' || state.url === '/'
                ? `/eula`
                : `/eula?${RouteQueryParams.TargetUrl}=${encodeURIComponent(state.url)}`;

        return combineLatest([this._userService.user$, this._eulaService.eulaIsAccepted$]).pipe(
            switchMap(([user, eulaIsAccepted]) => {
                const nonWhiteListClaims =
                    user === null || user.claims == null || user.claims == undefined
                        ? []
                        : Object.values(user.claims)[0].filter(
                              (value) => !this.eulaWhiteListClaims.includes(value)
                          );

                const userHasProspectClaim =
                    user === null
                        ? false
                        : Object.values(user.claims)[0].includes(DashboardClaim.ProspectApply);

                if (user === null) {
                    return of(this._router.parseUrl(loginUrl));
                }

                if (nonWhiteListClaims.length === 0 && user !== null && userHasProspectClaim) {
                    return of(this._router.parseUrl(getRouterLinkUrlById(atlas, AR_APPLICATION)));
                }

                if (!eulaIsAccepted) {
                    return of(this._router.parseUrl(eulaUrl));
                }
                return of(true);
            })
        );
    }
}
